import React, { Dispatch, DispatchWithoutAction, FC } from 'react';

import { fc } from 'i18n';
import Modal from 'core/react/general/Modal';
import DeviceSelector from 'core/react/share/devices/deviceSelector/DeviceSelector';

interface IDevicesModalProps {
  isSingle?: boolean;
  uris?: string[];
  closeModal: DispatchWithoutAction;
  onSubmit: Dispatch<string[]>;
}

export const DevicesModal: FC<IDevicesModalProps> = (props) => {
  const { isSingle, uris, closeModal, onSubmit } = props;

  return (
    <Modal className="object-device-manager" title={fc('select devices')} onClose={closeModal}>
      <DeviceSelector isSingle={isSingle} uris={uris || []} onSubmit={onSubmit} onCancel={closeModal} />
    </Modal>
  );
};
